import React from "react";
import { FaLinkedin, FaInstagram, FaFacebook, FaMedium, FaEnvelope } from "react-icons/fa";

const Index = () => {
  const handleScroll = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-gradient-to-r from-primary to-blue-800 text-white py-8">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <h3 className="text-2xl font-bold">CommerceMinder</h3>
            <p className="text-sm">The New Mind of Commerce</p>
          </div>

          <div className="mb-4 md:mb-0">
            <ul className="flex space-x-6">
              <li>
                <button
                  onClick={() => handleScroll("about")}
                  className="cursor-pointer hover:underline focus:outline-none"
                >
                  About
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleScroll("features")}
                  className="cursor-pointer hover:underline focus:outline-none"
                >
                  Features
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleScroll("contact")}
                  className="cursor-pointer hover:underline focus:outline-none"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div className="flex space-x-4 text-2xl">
            <a
              href="https://www.facebook.com/profile.php?id=61566345116436"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-gray-300"
            >
              <FaFacebook />
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-gray-300"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.linkedin.com/company/commerceminder/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-gray-300"
            >
              <FaLinkedin />
            </a>
            <a
              href="https://medium.com/@commerceminder"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-gray-300"
            >
              <FaMedium />
            </a>
            <a
              href="mailto:info@commerceminder.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-gray-300"
            >
              <FaEnvelope />
            </a>
          </div>
        </div>

        <div className="mt-8 text-center text-sm text-gray-200">
          <p>&copy; 2025 Commerce Minder. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Index;
